module.exports = __webpack_public_path__ + "img/testimonial-dark-01.886c5b36.jpg";